"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Spinner = void 0;

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Spinner =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Spinner, _React$Component);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, _getPrototypeOf(Spinner).apply(this, arguments));
  }

  _createClass(Spinner, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: this.props.className
      });
    }
  }]);

  return Spinner;
}(_react.default.Component);

exports.Spinner = Spinner;
var spin = (0, _styledComponents.keyframes)(["100%{transform:rotate(360deg);}"]);

var getSize = function getSize(props) {
  var base = {
    width: 25,
    height: 6 // tslint:disable-next-line

  };

  switch (props.spinnerSize) {
    case "small":
      return {
        width: base.width * 0.5,
        height: base.height * 0.5
      };

    case "medium":
      return {
        width: base.width * 0.8,
        height: base.height * 0.8
      };

    case "large":
      return {
        width: base.width,
        height: base.height
      };

    default:
      return {
        width: props.width,
        height: props.height
      };
  }
};

var StyledSpinner = (0, _styledComponents.default)(Spinner).withConfig({
  displayName: "Spinner__StyledSpinner",
  componentId: "sc-1a7qnq6-0"
})(["background:black;animation:", " 1s infinite linear;position:absolute;", ";"], spin, function (props) {
  var _getSize = getSize(props),
      width = _getSize.width,
      height = _getSize.height;

  return "\n      width: ".concat(width, "px;\n      height: ").concat(height, "px;\n      top: calc(50% - ").concat(height, "px / 2);\n      left: calc(50% - ").concat(width, "px / 2);\n    ");
});
StyledSpinner.defaultProps = {
  width: 25,
  height: 6
};
var _default = StyledSpinner;
exports.default = _default;
//# sourceMappingURL=Spinner.js.map